import { FormControl, Grid, InputAdornment, Stack, TextField } from '@mui/material';
import React from 'react'
import generalFunc from '../../Utils/generalFunc';
import { Typography } from '../../Styles/GlobalStyles/Variables';
import { CustomGreenButton } from '../Button/CustomButton';
import CustomAsynchronous from './CustomAsynchronous';
import Asynchronous from '../MangeSuccessfulBusiness/AutoComplete';
import { SwitchButton } from '../Button/SwitchButton';


const Forms = ({ spacing, formContent, readOnly }) => {
    return (
        <Grid container spacing={spacing ?? 1}>
            {formContent &&
                formContent?.map((input) =>
                    input?.type === "text" || input?.type === "number" || input?.type === "email" ? (
                        <Grid
                            key={input?.name}
                            item
                            md={input?.md || 12}
                            xs={input?.xs ?? 12}
                        >
                            <FormControl variant="outlined" fullWidth>
                                <label
                                    style={{
                                        marginBottom: "10px",
                                        fontFamily: Typography.secondaryFont,
                                    }}
                                    htmlFor={input?.name}
                                >
                                    {input?.label}
                                </label>
                                <TextField
                                    name={input?.name}
                                    error={input?.error}
                                    value={input?.name === "email" ? input?.value : generalFunc.firstLetterUppercase(input?.value || '')}
                                    helperText={input?.helperText}
                                    size="small"
                                    id={input?.name}
                                    variant="outlined"
                                    onChange={input?.onChange}

                                    InputProps={{
                                        spellCheck: true,
                                        lang: "English",
                                        readOnly: (input?.isReadOnly || readOnly) ?? false,
                                        ...(input?.type === "number" && {
                                            inputMode: "numeric", pattern: "[0-9]*",
                                            startAdornment: <InputAdornment position="start">+234</InputAdornment>,

                                        })
                                    }}
                                    type={input?.type}
                                    onBlur={input?.onBlur && input?.onBlur}
                                />

                            </FormControl>
                        </Grid>
                    )
                        : input?.type === "button" ? (
                            <Grid
                                key={input?.name}
                                item
                                xs={input?.xs || 12}
                                md={input?.md || 12}
                            >
                                <FormControl
                                    sx={{
                                        height: input?.height ?? "100%",
                                        ...(input?.center === true && {
                                            marginTop: { lg: "-30px", md: "0px" },
                                        }),
                                    }}
                                    fullWidth
                                >
                                    <CustomGreenButton
                                        style={{
                                            height: input?.height ?? "100%",
                                            // ...(input?.colorGroup && {
                                            //     background:
                                            //         theme.palette[input?.colorGroup][
                                            //         input?.colorType ?? "main"
                                            //         ],
                                            // }),
                                        }}
                                        text={input?.label}
                                        loading={Boolean(input?.loading)}
                                        name={input?.name}
                                        onClick={input?.onClick}
                                        disabled={input?.disabled}
                                    />
                                </FormControl>
                            </Grid>
                        ) : input?.type === "spacer" ? (
                            <Grid
                                key={input?.name}
                                item
                                xs={input?.xs || 12}
                                md={input?.md || 12}
                            >
                                {/* Transparent empty spacer */}
                                <div style={{ width: "100%", height: 0 }} />
                            </Grid>
                        ) : input?.type === "asynchronous" ? (
                            <Grid
                                key={input?.name}
                                item
                                xs={input?.xs || 12}
                                md={input?.md || 12}
                            >
                                <FormControl fullWidth>
                                    <label
                                        style={{
                                            marginBottom: "10px",
                                            fontFamily: Typography.secondaryFont,
                                        }}
                                        htmlFor="skill"
                                    >
                                        {input?.label}
                                    </label>
                                    <CustomAsynchronous
                                        name={input?.name}
                                        options={input?.options}
                                        onChange={input?.onChange}
                                        value={input?.value}
                                        error={input?.error}
                                        helperText={input?.helperText}
                                        dispatchAction={input?.dispatchAction}
                                        disabled={readOnly}
                                    />
                                </FormControl>

                            </Grid>
                        ) : input?.type === "switch" ? (
                            <Grid
                                key={input?.name}
                                item
                                xs={input?.xs || 12}
                                md={input?.md || 12}
                            >
                                <FormControl fullWidth variant="outlined">
                                    <label
                                        style={{
                                            marginBottom: "10px",
                                            fontFamily: Typography.secondaryFont,
                                        }}
                                        htmlFor={input?.name}
                                    >
                                        <p sx={{
                                            fontSize: "14px",
                                            fontFamily: Typography.secondaryFont,
                                        }}>
                                            {input?.label}
                                        </p>
                                    </label>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <SwitchButton
                                            defaultChecked
                                            inputProps={{ "aria-label": "ant design" }}
                                            name={input?.name}
                                            checked={input?.value}
                                            onChange={input?.onChange}
                                        />
                                        <p
                                            style={{
                                                color: input?.value
                                                    ? "#016c34"
                                                    : "#bfbfbf",
                                                fontFamily: Typography.secondaryFont,
                                            }}
                                        >
                                            {input?.value
                                                ? "Active"
                                                : "Inactive"}
                                        </p>
                                    </Stack>
                                </FormControl>

                            </Grid>
                        ) : (
                            ""
                        )
                )}
        </Grid>
    )
}

export default Forms